<template>
    <div class="calendar-d-input pl-3 pr-3">
      <div class="input-group">
        <input
          type="date"
          class="form-control"
          v-model="formattedDate"
          @change="handleDateChange"
        />
      </div>
    </div>
  </template>
  
  <script>
  /**
   * @author Daniel Jesus Hdz Fco
   */
  export default {
    //template: '#datepicker-select-dview',
    /*
      props: [
          "startDate",
          "minDate",  //fecha minima!!
          'includedayp'
      ],*/
    props: {
      checkBoxIsSelected: {
        type: Boolean,
        default: false,
      },
      startDate: {
        type: Date,
        default: function () {
          return new Date();
        },
      },
      minDate: Date, //fecha minima!!
      includedayp: {
        type: Boolean,
        default: true,
      },
    },
    data: function () {
      //desde 2011 se puede recuperar facturas, entocnes iniciar desde ese instannte
      console.log("iniciado");
      console.debug(this);
      /*
          var IncludeDay=false;
          if(this.includedayp){
              IncludeDay=this.includedayp;
          }else{
              IncludeDay=true;
          } 
          */
      var year = new Date().getFullYear();
      var month = new Date().getMonth() + 1; // los meses de javascript estan basados en indice 0
      var day = new Date().getDate();
      //console.log("alo actual" + year);
      var lstYears = [];
      for (var inicio = 2011; inicio <= year; inicio++) {
        lstYears.push(inicio);
      }
      var weekday = new Array(7);
      weekday[0] = "Domingo";
      weekday[1] = "Lunes";
      weekday[2] = "Martes";
      weekday[3] = "Miercoles";
      weekday[4] = "Jueves";
      weekday[5] = "Viernes";
      weekday[6] = "Sabado";
      //sin importar si nos dan fechaInicializacion, debemos de emitir la fecha para que el componente padre la reciba
      //  var startDate = this.startDate?this.startDate:new Date();
      var startDate;
      if (!this.startDate) {
        startDate = new Date();
        day = startDate.getDate();
        month = startDate.getMonth() + 1;
        year = startDate.getFullYear();
        this.$emit("dateChanged", startDate);
      } else {
        startDate = this.startDate;
        day = this.startDate.getDate();
        month = this.startDate.getMonth() + 1;
        year = this.startDate.getFullYear();
        this.$emit("dateChanged", this.startDate);
      }
  
      // console.log(lstYears);
      console.debug("return");
      return {
        years: lstYears,
  
        //
        months: [
          //months in java script are zero-indexed
          { index: 1, descripcion: "Enero" },
          { index: 2, descripcion: "Febrero" },
          { index: 3, descripcion: "Marzo" },
          { index: 4, descripcion: "Abril" },
          { index: 5, descripcion: "Mayo" },
          { index: 6, descripcion: "Junio" },
          { index: 7, descripcion: "Julio" },
          { index: 8, descripcion: "Agosto" },
          { index: 9, descripcion: "Septiembre" },
          { index: 10, descripcion: "Octubre" },
          { index: 11, descripcion: "Noviembre" },
          { index: 12, descripcion: "Diciembre" },
        ],
        daysOfWeeek: weekday,
        selectedYear: year,
        selectedMonth: month,
        selectedDay: day,
        date: startDate,
        showCalendar: false,
        Selfelemento: undefined,
        // includeDay:IncludeDay,
        classMes: {
          "col-5": this.includedayp, //si es tru
          "col-6": !this.includedayp, //false
        },
        classYear: {
          "col-4": this.includedayp, //true
          "col-6": !this.includedayp,
        },
        //days: []//esta debe ser un computed propiertis ya que cambia de mes en mes
      };
    },
    mounted() {
      console.debug("DatePicker");
      console.debug(this);
      this.Selfelemento = this.$el;
      var me = this;
      document.addEventListener("click", function (event) {
        //   console.debug(event.target);
        var isClickInside = me.Selfelemento.contains(event.target);
        if (!isClickInside) {
          me.showCalendar = false;
        }
        //  console.debug("fin click");
      });
    },
    methods: {
      handleDateChange: function () {
        this.$emit("dateChanged", this.date); // Emitir el evento con la nueva fecha
      },
      // Month here is 1-indexed (January is 1, February is 2, etc). This is
      // because we're using 0 as the day so that it returns the last day
      // of the last month, so you have to add 1 to the month number
      // so it returns the correct amount of days
      daysInMonth(month, year) {
        return new Date(year, month, 0).getDate();
      },
      getNameDate(day, month, year) {
        console.log("getNameDate");
        console.log(year + "dia del mes " + month + "dia :" + day);
        var diaSemana = new Date(year, month, day).getDay();
        console.log("dia de la semana" + diaSemana);
        return this.daysOfWeeek[diaSemana];
      },
      /**
       * Actuliza el date y emite el evento de cambio de valor
       */
      cambioFecha: function () {
        var date = new Date(
          this.selectedYear,
          this.selectedMonth - 1,
          this.selectedDay
        );
        this.date = date;
        this.$emit("dateChanged", date);
      },
      /**
       * desabilita el option en el view
       * @param {*} itemValue valor
       * @param {*} type puede ser, year,month,day
       */
      disableItemOptionIfIsMinorThanMinDate(itemValue, type) {
        if (!this.minDate || !(this.minDate instanceof Date)) {
          //  console.debug("No hay fecha minima");
          return;
        }
        console.info("disableItemOptionIfIsMinorThanMinDate");
        //console.debug(arguments);
        if (type === undefined) {
          console.error("falta el type");
        }
        //console.log("fecha minima");
        //console.log(this.minDate);
  
        if ("year" == type) {
          //console.log("year");
          if (this.minDate.getFullYear() > itemValue) {
            // console.log("es menor")
            return true;
          }
          return false;
        }
        if ("month" == type) {
          // console.log("month");
          if (this.minDate.getFullYear() >= this.selectedYear) {
            //    console.log("month");
            if (this.minDate.getMonth() + 1 > itemValue) {
              console.log("truee");
              return true;
            }
          }
          return false;
        }
        if ("day" == type) {
          //console.debug("day");
          var min = this.minDate.getMonth() + 1;
          if (min >= this.selectedMonth) {
            //console.debug("mes es mayo al minimo");
            return this.minDate.getUTCDate() > itemValue ? true : false;
          }
          // console.debug("mes " + min + "es menor a " + this.selectedMonth);
        }
      },
      getMonthName(zeroIndex) {
        //console.log("getMonthName");
        //console.debug(arguments);
        if (zeroIndex >= 0 && zeroIndex <= this.months.length) {
          return this.months[zeroIndex].descripcion;
        }
        return "";
      },
      cambioMes(newSelectedMonthValue) {
        if (newSelectedMonthValue > 0 && newSelectedMonthValue <= 12) {
          var res;
          if (this.minDate) {
            //si existe una fecha mininam entonces
            res = this.disableItemOptionIfIsMinorThanMinDate(
              newSelectedMonthValue,
              "month"
            );
          }
          if (res == true) {
            //si es true entonces no aceptamos el cambio, no hago el disable en el frontend porque no funciona este atributo en los span
            return;
          }
          this.selectedMonth = newSelectedMonthValue;
          var maxDay = this.daysInMonth(this.selectedMonth, this.selectedYear);
          //console.debug(maxDay);
          if (maxDay < this.selectedDay) {
            //this.selectedDay=this.selectedMonth
            this.selectedDay = 1;
          }
          this.cambioFecha();
        }
      },
    },
    computed: {
      formattedDate: {
        get: function () {
          return this.date.toISOString().substr(0, 10); // Formato YYYY-MM-DD
        },
        set: function (newValue) {
          const newDate = new Date(newValue);
          if (!isNaN(newDate.getTime())) {
            this.date = newDate;
          }
        },
      },
      /**
       * Obtenemos los dias segun cambie el mes y año
       */
      days: function () {
        console.log("computed:days");
        if (!this.selectedYear || !this.selectedMonth) {
          console.log("regrsando");
          return [];
        }
        // console.log(this.selectedMonth);
        // console.log(this.selectedYear);
        var lastday = this.daysInMonth(this.selectedMonth, this.selectedYear);
        // console.log(lastday);
        var days = [];
        for (var day = 1; day <= lastday; day++) {
          //  var name=this.getNameDate(day,this.selectedMonth,this.selectedYear);
          //  days.push(day+" "+name);
          days.push(day);
        }
        //   console.log(days);
        return days;
      },
      // eslint-disable-next-line vue/return-in-computed-property
      fecha: function () {},
      getMonthNameComputed: function () {
        // return ' '+this.getMonthName(this.date.getMonth())+' de '+this.date.getFullYear()
        return (
          " " +
          this.getMonthName(this.selectedMonth - 1) +
          " de " +
          this.date.getFullYear()
        );
      },
    },
    watch: {
      //el watch se debe llamar igual que el prop que observamos
      /**
       * Observamos el valor minDate , de manera que el valor seleccionado , sea igual o mayor a minDate.
       * El mes depende del año, y el dia del mes y año, dada esta formulacion, siempre que un elemento exceda a otro
       * se llevara a ese maximo, ejemplo si el año es mayor, se llevara a ese año, asi con el mes y dia respectivamente
       */
      minDate: function (newVal) {
        if (newVal && newVal instanceof Date) {
          //si el año es mayor lo llevamos año
          if (newVal.getFullYear() > this.selectedYear) {
            this.selectedYear = newVal.getFullYear();
            this.cambioFecha();
          }
          //si es igual mayor o igual el año, y el mes es mayor entonces lo llevamos a ese mes
          if (
            newVal.getFullYear() == this.selectedYear &&
            newVal.getMonth() + 1 > this.selectedMonth
          ) {
            this.selectedMonth = newVal.getMonth() + 1;
            this.cambioFecha();
          }
          //si es el mismo año , y mes , lo llevamos al dia correspondiente
          if (
            newVal.getFullYear() == this.selectedYear &&
            newVal.getMonth() + 1 == this.selectedMonth
          ) {
            if (newVal.getUTCDate() > this.selectedDay) {
              this.selectedDay = newVal.getUTCDate(); //retorna el dia dentro del mes
              this.cambioFecha();
            }
          }
        }
      },
      checkBoxIsSelected: function () {
        this.cambioFecha();
      },
    },
  };
  </script>